// DO NOT EDIT: autogenerated by brokkr
import { CreateIconOptions } from "./types";
export const falH: CreateIconOptions = {
  "displayName": "FALH",
  "viewBox": "0, 0, 384, 512",
  "d": "M352 256l0 208c0 8.8 7.2 16 16 16s16-7.2 16-16l0-240 0-176c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 176L32 224 32 48c0-8.8-7.2-16-16-16S0 39.2 0 48L0 464c0 8.8 7.2 16 16 16s16-7.2 16-16l0-208 320 0z"
};
